export const ValidateRule = {
  Required: 'required',
  HalfWidthNumber: 'halfWidthNumber',
  HalfWidthRealNumber: 'halfWidthRealNumber',
  NegativeNumber: 'negativeNumber',
  MemoInvalidChar: 'memoInvalidChar',
  MemoTooMuchLength: 'memoTooMuchLength',
};

/**
 * バリデーションルール
 */
export type ValidateRule = (typeof ValidateRule)[keyof typeof ValidateRule];

/**
 * フィールドのアイテム
 */
export type FieldItem = {
  /**
   * フィールド名
   */
  name: string;
  /**
   * バリデーションルール
   */
  rules: readonly ValidateRule[];
};
